import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import "./_buildingShimmer.scss";

// Base shimmer block — a single animated placeholder.
// Reused to compose the skeletons below so the sweep animation is identical everywhere.
export const Shimmer = ({ width = "100%", height = 16, radius = 8, style = {} }) => (
    <span className="bc-shimmer" style={{ width, height, borderRadius: radius, ...style }} />
);

// Skeleton for the building accordion list (branch-search results).
export const BuildingListShimmer = ({ rows = 3 }) => (
    <div className="hostel-accordion mt-4">
        {Array.from({ length: rows }).map((_, i) => (
            <Card key={i} style={{ marginBottom: 10, border: "1px solid #eef2f7", borderRadius: 12, overflow: "hidden" }}>
                <div style={{ padding: "16px 20px", background: "#f8fafc" }}>
                    <Row className="align-items-center">
                        <Col lg={1} md={12} sm={12}><Shimmer width={18} height={18} radius={4} /></Col>
                        <Col lg={3} md={12} sm={12}><Shimmer width="70%" height={16} /></Col>
                        <Col lg={2} md={12} sm={12}><Shimmer width={90} height={22} radius={11} /></Col>
                        <Col lg={2} md={12} sm={12}><Shimmer width={90} height={22} radius={11} /></Col>
                        <Col lg={2} md={12} sm={12}><Shimmer width={90} height={22} radius={11} /></Col>
                        <Col lg={2} md={12} sm={12}><Shimmer width={32} height={32} radius={8} style={{ marginLeft: "auto" }} /></Col>
                    </Row>
                </div>
            </Card>
        ))}
    </div>
);

// Skeleton for the building form (branch / name / floors inputs + floor rows).
export const BuildingFormShimmer = ({ rows = 3 }) => (
    <div>
        <Row>
            {[0, 1, 2].map((i) => (
                <Col lg={4} md={12} sm={12} className="mb-3" key={i}>
                    <Shimmer width="40%" height={10} style={{ marginBottom: 8 }} />
                    <Shimmer width="100%" height={42} radius={10} />
                </Col>
            ))}
        </Row>
        {Array.from({ length: rows }).map((_, i) => (
            <Row className="mt-2" style={{ marginLeft: 0, marginRight: 0 }} key={i}>
                <Col lg={3} md={12} sm={12} className="mb-2 px-1"><Shimmer height={42} radius={10} /></Col>
                <Col lg={3} md={12} sm={12} className="mb-2 px-1"><Shimmer height={42} radius={10} /></Col>
                <Col lg={2} md={12} sm={12} className="mb-2 px-1"><Shimmer height={42} radius={10} /></Col>
                <Col lg={3} md={12} sm={12} className="mb-2 px-1"><Shimmer height={42} radius={10} /></Col>
                <Col lg={1} md={12} sm={12} className="mb-2 px-1" />
            </Row>
        ))}
    </div>
);

// Full-page skeleton for the initial page load (tab header + card + form + list).
export const BuildingPageShimmer = () => (
    <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", overflow: "hidden", marginTop: 16, marginBottom: 100 }}>
        {/* Tab header */}
        <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "16px 24px", display: "flex", gap: 12 }}>
            <Shimmer width={160} height={30} radius={8} />
            <Shimmer width={160} height={30} radius={8} />
        </div>
        {/* Body */}
        <div style={{ padding: 28 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 22 }}>
                <Shimmer width={38} height={38} radius={10} />
                <div style={{ flex: 1 }}>
                    <Shimmer width={190} height={16} style={{ marginBottom: 8 }} />
                    <Shimmer width={280} height={10} />
                </div>
                <Shimmer width={140} height={38} radius={10} />
            </div>
            <BuildingFormShimmer rows={0} />
            <BuildingListShimmer rows={3} />
        </div>
    </div>
);
